import i18n from '@/api/i18n/i18n';

const typeDict = {
  0: i18n.t('pages.typeDict.text'),
  1: i18n.t('pages.typeDict.files'),
  2: i18n.t('pages.typeDict.screenshot'),
};

export const type = (val) => typeDict[val];
